import wretch from 'wretch';
import formData from 'wretch/addons/formData';
import queryString from 'wretch/addons/queryString';

// API URL constants
export const ANNOUNCEMENT_API_URL = '/announcement';
export const AUCTION_API_URL = '/auctions';
export const AUTH_API_URL = '/authorization';
export const CLIENT_API_URL = '/clients';
export const MED_BILLING_API_URL = '/medbilling';
export const NOTIFICATION_API_URL = '/notifications';
export const PERFORMANCE_API_URL = '/performance';
export const RATE_SETTER_API_URL = '/ratesetter';
export const REFERENCE_API_URL = '/reference';
export const SCOPE_ASSESSOR_API_URL = '/scope-assessor';
export const USER_SUPPORT_API_URL = '/user-support';
export const WORKLIST_API_URL = '/worklist';
export const TREATMENT_API_URL = '/treatment';

/** Singleton for base wretcher. Bearer token is added on login. */
export const fmhAPI = {
    base: wretch(process.env.REACT_APP_BASE_URL).addon(formData).addon(queryString),
};

/** Returns wretcher w/ Bearer token and optional x-npi header */
export const fmhNpiAPI = ({
    url,
    npi,
}: {
    /** url to append to the BASE_URL */
    url: string;
    /** optional npi to be sent as x-npi header */
    npi?: string;
}) => fmhAPI.base.headers(npi ? { 'x-npi': npi } : {}).url(url);
